const translations = {
  "en": {
    "Agent": "Agent",
    "Fast": "Fast",
    "Think": "Think"
  },
  "zh-tw": {
    "Agent": "Agent",
    "Fast": "快速",
    "Think": "思考"
  }
};

export default translations;
